import React from 'react';
import { Link } from 'react-router-dom';
import PropTypes from 'prop-types';
import cx from 'classnames';
import { Card, Progress, Switch, Input, Menu, Dropdown, Col, Slider, Modal, Collapse, Badge, Tooltip } from 'antd';
import history from '../modules/history';
// import { eventGA } from '../modules/ganalytics';
import {
  EllipsisOutlined,
  EditOutlined,
  HighlightOutlined,
  SolutionOutlined,
  FormOutlined,
  RiseOutlined,
  CopyOutlined,
  DeleteOutlined,
  WarningOutlined,
  DownOutlined,
} from '@ant-design/icons';

const { TextArea } = Input;

export default class VariantItem extends React.Component {
  static propTypes = {
    urlsafe: PropTypes.string,
    pageUrlsafe: PropTypes.string,
    name: PropTypes.string,
    tutorial: PropTypes.bool.isRequired,
    note: PropTypes.string,
    distribution: PropTypes.number,
    enabled: PropTypes.bool,
    totalDistribution: PropTypes.number,
    status: PropTypes.string,

    onPageVariantDelete: PropTypes.func.isRequired,
    onPageVariantClone: PropTypes.func.isRequired,
    onPageVariantAttributeChange: PropTypes.func.isRequired,
    onPageVariantDistibutionChange: PropTypes.func.isRequired,
  };

  onPageVariantClone = () => {
    this.props.onPageVariantClone(this.props.urlsafe);
  };

  onDistributionChange = (value) => {
    this.props.onPageVariantDistibutionChange(this.props.urlsafe, value);
  };

  onDistributionAfterChange = (value) => {
    this.props.onPageVariantAttributeChange(this.props.urlsafe,
      [{ key: 'distribution', type: 'number', val: value }]
    );
  };

  onNameBlur = (e) => {
    const newVal = e.target.value;
    if (newVal !== this.props.name) {
      this.props.onPageVariantAttributeChange(this.props.urlsafe,
        [{ key: 'name', type: 'string', val: newVal }]
      );
    }
  };

  onNoteBlur = (e) => {
    const newVal = e.target.value;
    if (newVal !== this.props.note) {
      this.props.onPageVariantAttributeChange(this.props.urlsafe,
        [{ key: 'note', type: 'string', val: newVal }]
      );
    }
  };

  onEnabledChange = (value) => {
    if (value) {
      // eventGA({
      //   category: 'pages',
      //   action: 'enable_variant',
      // });
    }
    else {
      // eventGA({
      //   category: 'pages',
      //   action: 'disable_variant',
      // });
    }

    this.props.onPageVariantAttributeChange(
      this.props.urlsafe,
      [{ key: 'enabled', type: 'bool', val: value }],
    );
  }

  renderProgressFormat = (percent) => {
    if (this.props.enabled) {
      return (`${percent}%`);
    }
    return '';
  }

  getEditorUrl = () => {
    const { tutorial, urlsafe } = this.props;
    return tutorial ? `editor/tutorial/${urlsafe}` : `editor/${urlsafe}`;
  }

  getLeadsUrl = () => (
    `leads/${this.props.urlsafe}`
  );

  onPageVaraintOpenEditor = () => {
    // eventGA({ category: 'pages', action: 'open_design_editor' });
    history.push(this.getEditorUrl());
  }

  onLeadsClick = () => {
    // eventGA({ category: 'pages', action: 'view_leads' });
    history.push({
      pathname: '/leads',
      navPageUrlsafe: this.props.pageUrlsafe,
      navVariantUrlsafe: this.props.urlsafe,
    });
  }

  deleteAfterConfirm = () => {
    Modal.confirm({
      icon: <WarningOutlined />,
      title: "Are you sure?",
      content: "This variant and leads generated from it will be deleted. This action cannot be undone. If unsure, consider taking it offline instead.",
      cancelText: "Never Mind",
      cancelType: "primary",
      okText: "Delete",
      okType: "danger",
      maskClosable: true,
      onOk: () => {
        this.props.onPageVariantDelete(this.props.urlsafe);
      },
    });
  };
  render() {
    const {
      // urlsafe,
      status,
      name,
      note,
      distribution,
      totalDistribution,
      enabled,
      // tutorial,
    } = this.props;

    const isLoading = (typeof status === 'undefined') ?
      false : (status === 'loading');

    const overFlowMenu = (
      <Menu>
        <Menu.Item key="design" onClick={this.onPageVaraintOpenEditor}>
          <EditOutlined />Open design editor
        </Menu.Item>
        <Menu.Item key="clone" onClick={this.onPageVariantClone}>
          <CopyOutlined />Clone this variant
        </Menu.Item>
        <Menu.Item key="leads" onClick={this.onLeadsClick}>
          <RiseOutlined />View generated leads
        </Menu.Item>
        <Menu.Divider />
        <Menu.Item key="delete" className="text-danger" onClick={this.deleteAfterConfirm}>
          <DeleteOutlined />Delete this Variant
        </Menu.Item>
      </Menu>
    );

    const overFlowDropdown = (
      <Dropdown key="overflow" overlay={overFlowMenu} trigger={['click']}>
        <EllipsisOutlined style={{ verticalAlign: "baseline" }} />
      </Dropdown>
    );

    const distributionPercentage = Math.round((100 * distribution) / totalDistribution);

    const editorUrl = this.getEditorUrl();
    const leadsUrl =  this.getLeadsUrl();

    return (
      <Col
        xs={24} sm={12} md={12}
        lg={8} xl={8}
        style={{ padding: '8px' }}
      >
        <Card
          bodyStyle={{ padding: 0 }}
          bordered={false}
          loading={isLoading}
          className="mb-3 shadow-sm rounded overflow-hidden"
          hoverable={false}
          actions={[
            <Link key="edit" to={editorUrl} className="">
              <Tooltip title="Design this page variant." placement="bottomLeft">
                <HighlightOutlined className="mr-2" />
                <div className="d-inline uifont">edit</div>
              </Tooltip>
            </Link>,
            <Link
              key="leads"
              to={{
                pathname: '/leads',
                navPageUrlsafe: this.props.pageUrlsafe,
                navVariantUrlsafe: this.props.urlsafe,
              }}
            >
              <Tooltip title="Show leads generated from this page variant." placement="bottom">
                <RiseOutlined className="mr-2" />
                <div className="d-inline uifont">leads</div>
              </Tooltip>
            </Link>,
            overFlowDropdown,
          ]}
        >

          <div className="mb-3 pt-3 px-3 text-left">
            <Switch
              size="small"
              className="variant__enabled__switch"
              defaultChecked={enabled}
              onChange={this.onEnabledChange}
            />
            <div className="d-inline uifont ml-2 text-secondary">
              { enabled ? 'Published' : 'Tap to publish' }
            </div>
          </div>

          <div className="px-3" style={{ marginLeft: '-10px', marginRight: '-10px' }} >
            <Input
              placeholder="Name this variant"
              defaultValue={name}
              onBlur={this.onNameBlur}
              className="variant__name"
              onPressEnter={this.onNameBlur}
              spellCheck={false}
            />
            <TextArea
              placeholder="Add a note"
              defaultValue={note}
              autoSize={{ maxRows: 5 }}
              className="variant__note"
              onBlur={this.onNoteBlur}
              spellCheck={false}
            />
          </div>

          <div className="px-3 mb-3">
            <div className="traffic-container rounded overflow-hidden">
              { enabled ? (
                <Collapse bordered={false} defaultActiveKey={[]} className="variant__item__collapse">
                  <Collapse.Panel
                    key="traffic" showArrow={true}
                    header={
                      <div
                        className={cx( 'd-flex', 'align-items-center', 'flex-grow-1',
                          { 'justify-content-between': this.props.enabled },
                          { 'justify-content-around': !this.props.enabled },
                        )}
                        style={{ height: 36 }}
                      >
                        <React.Fragment>
                          <div className="text-primary flex-grow-1">Traffic split</div>
                          <div>
                            <Progress
                              type="dashboard" status="active" width={36}
                              percent={(this.props.enabled) ? distributionPercentage : 0}
                              format={this.renderProgressFormat}
                            />
                          </div>
                        </React.Fragment>
                      </div>
                    }
                  >
                    <Slider
                      min={1} max={100} disabled={!this.props.enabled}
                      defaultValue={distribution} onChange={this.onDistributionChange}
                      onAfterChange={this.onDistributionAfterChange}
                    />
                  </Collapse.Panel>
                </Collapse>
              ) : (
                <div className="text-muted d-flex align-items-center justify-content-center p-2 text-center uifont" style={{ height: 60 }}>
                  Traffic disabled when offline
                </div>
              )}
            </div>
          </div>

        </Card>
      </Col>
    );
  }
}



// WEBPACK FOOTER //
// ./scripts/components/VariantItem.jsx